import { render, staticRenderFns } from "./BulkEditGames.vue?vue&type=template&id=5059998c&scoped=true&"
import script from "./BulkEditGames.vue?vue&type=script&lang=js&"
export * from "./BulkEditGames.vue?vue&type=script&lang=js&"
import style0 from "./BulkEditGames.vue?vue&type=style&index=0&id=5059998c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5059998c",
  null
  
)

export default component.exports